module.exports = __webpack_public_path__ + "static/media/alert_sound.ccca3bd.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/alert_sound.ogg
// module id = 9fA2
// module chunks = 102